module.exports = __webpack_public_path__ + "h5/img/logo2.cc9ce3d6.png";